import {useCallback, useState} from 'react';
import * as React from 'react';
import {useDispatch} from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import routeByName from '~/constants/routes';
import {hideUpgradePaidPopup} from '~/modules/CurrentUser/store/actions';
import {navigateAction} from '~/actions/navigateActions';
import useModalById from '~/customHooks/useModalById';
import {MODAL_UPGRADE_TO_PAID} from '~/rootStore/modals/modalsIds';

import imageUpgradeToPaid from './img/upgrade-to-paid.svg';
import ModalBase from '../ModalBase';

interface Props {
  simple?: boolean;
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
}));

const ModalUpgradeToPaid: React.FC<Props> = ({simple}) => {
  const s = useStyles();
  const {isOpen, close: onClose} = useModalById(MODAL_UPGRADE_TO_PAID);

  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState<boolean>(isOpen);

  const close = useCallback(() => {
    dispatch(hideUpgradePaidPopup());
    setShowModal(false);
    onClose();
  }, [dispatch, onClose]);

  const handleClose = () => {
    close();
  };

  const handleActionClick = useCallback(() => {
    dispatch(navigateAction(routeByName.chooseMembership));
    close();
  }, [close, dispatch]);

  return (
    <ModalBase
      showSkipButton
      showCloseButton
      open={simple ? isOpen : showModal}
      onClose={simple ? onClose : handleClose}
    >
      <div className={s.wrapper}>
        <Box mb={2}>
          <img src={imageUpgradeToPaid} alt="upgrade to vip" />
        </Box>
        <Box mb={1}>
          <Typography variant="h6">
            <b>Upgrade Profile to Paid</b>
          </Typography>
        </Box>
        <Box mb={3} textAlign="center">
          <Typography variant="body2">
            and be seen by thousands of clients in your area everyday
          </Typography>
        </Box>
        <Box alignSelf="stretch">
          <Button fullWidth onClick={handleActionClick}>
            <b>Upgrade Profile to Paid</b>
          </Button>
        </Box>
      </div>
    </ModalBase>
  );
};

export default ModalUpgradeToPaid;
